import Rendimiento from "./Rendimiento";

export default Rendimiento;